module.exports = __webpack_public_path__ + "images/emails/hero/invite@2x-1b9d55c9.png";